import { useMutation, useQuery } from "@apollo/client";
import { FORM_TEMPLATE_SYSTEM_KEY, gql } from "types";

export const GET_USER_EMPLOYMENT = gql(/* GraphQL */ `
  query GetUserEmployment {
    user {
      id
      email
      fatcaDetails
      employments {
        id
      }
    }
  }
`);

export const GET_EMPLOYEE_FATCA_FORM_TEMPLATE = gql(/* GraphQL */ `
  query GetEmployeeFatcaFormTemplate($systemKey: String!) {
    formTemplateLatestPublishedVersion(systemKey: $systemKey) {
      id
      formTemplateId
      snapshot {
        name
        description
        fields {
          id
          type
          order
          variant
          name
          label
          content
          description
          placeholder
          required
          validation
          options {
            id
            value
            label
          }
          multi
          layout
        }
      }
    }
  }
`);

export const SUBMIT_USER_FATCA_FORM = gql(/* GraphQL */ `
  mutation SubmitUserFatcaForm($data: JSON!) {
    submitUserFatcaForm(data: $data) {
      id
      fatcaDetails
    }
  }
`);

// Custom Hooks
export const useUserEmployment = () => {
  const { data, loading, error, refetch } = useQuery(GET_USER_EMPLOYMENT);

  const user = data?.user;
  const currentEmployee = data?.user?.employments?.[0];

  return {
    currentEmployee,
    user,
    loading,
    error,
    refetch,
  };
};

export const useEmployeeFatcaForm = (
  systemKey: string = FORM_TEMPLATE_SYSTEM_KEY.employeeFatca,
) => {
  const { data, loading, error, refetch } = useQuery(
    GET_EMPLOYEE_FATCA_FORM_TEMPLATE,
    {
      variables: { systemKey },
    },
  );

  const formTemplate = data?.formTemplateLatestPublishedVersion?.snapshot;

  return {
    formTemplate,
    loading,
    error,
    refetch,
  };
};

export const useSubmitUserFatcaForm = () => {
  const [submitUserFatcaForm, { loading, error }] = useMutation(
    SUBMIT_USER_FATCA_FORM,
  );

  const submitForm = async (data: Record<string, unknown>) => {
    const result = await submitUserFatcaForm({
      variables: { data },
    });

    return result.data?.submitUserFatcaForm;
  };

  return {
    submitForm,
    loading,
    error,
  };
};
